<template>
<!--  <div class="logincon" v-if="showsurvey" @click="handleClose">-->
    <div class="logincon">
    <div :class="['info-con',{'survey':activeTab=='survey','persurvey':activeTab=='persurvey'}]" @click="notClose">

  <div class="closebutton" @click="handleClose">关闭</div>
  <div class="two-title">
    <div :class="['survey-title',{'active':activeTab=='survey'}]" @click="activeTab='survey'">机构投资者问卷调查</div>
    <div :class="['survey-title',{'active':activeTab=='persurvey'}]" @click="activeTab='persurvey'">个人投资者问卷调查</div>
  </div>
  <div class="text scroll-con" v-if="activeTab=='survey'">
    <p>尊敬的客户：</p>
    <p>
      您好！为了给您提供更优质的服务，请您花费几分钟的时间，如实选择以下调查问卷题目选项，本表可协助评估您对私募基金及投资目标相关风险的态度，确定您对投资风险的适应力，进而为您推荐更适合投资的产品。衷心感谢您对我们的支持与信任。</p>

    <p>重要提示：</p>
    <p>1、请投资者认真阅读问卷内容，了解评分规则，并确认所填写内容表达真实。</p>
    <p>2、本网站根据投资者的风险承受能力等级，对投资者的投资行为作出是否匹配的检查和提示。本次调查结果不构成对投资者的投资建议，或对投资者的投资决策形成实质影响</p>
    <p>3、投资有风险，可能导致投资者产生亏损，请投资者在购买过程中注意根据调查结果核对自己的风险承受能力和基金产品风险匹配情况。无论投资者是否根据调查结果进行投资，均属投资者的独立行为，相应的风险亦由投资者独立承担。</p>
    <p>4、投资人得分越高，说明投资者的风险承受能力越强。</p>
    <!--        <p>4、本问卷共设计了19道问题，投资人得分越高，说明投资者的风险承受能力越强。</p>-->

    <p>调查题目（所有题目均为单选题）</p>
    <div v-for="(item,index) in institutionPaper.questionType" :key="index">
      <p>{{item.typeName}}</p>
      <div v-for="(question,inde) in item.question" v-if="question.isMultiple==0" :key="question.questionId">
        <p>{{inde+1}}.{{question.questionBody}}</p>
        <div v-for="(questionoption,ind) in question.optionBodys" :key="questionoption.id">
          <p><span><input :name="question.questionId" @click="submitOption(question.questionId,questionoption.id)"
                          type="radio" :value="questionoption.id" :checked="questionoption.defaultAnswers"/>{{String.fromCharCode(ind+65)}}.{{questionoption.body}}</span>
          </p>
        </div>
      </div>
      <div v-for="(question,inde) in item.question" v-if="question.isMultiple==1" :key="question.questionId">
        <p>{{inde+1}}.{{question.questionBody}}</p>
        <div v-for="(questionoption,ind) in question.optionBodys" :key="questionoption.id">
          <p><span><input :name="question.questionId" @click="submitOption(question.questionId,questionoption.id)"
                          type="checkbox" :value="questionoption.id" :checked="questionoption.defaultAnswers"/>{{String.fromCharCode(ind+65)}}.{{questionoption.body}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="text scroll-con" v-if="activeTab=='persurvey'">
    <p>尊敬的客户：</p>
    <p>
      您好！为了给您提供更优质的服务，请您花费几分钟的时间，如实选择以下调查问卷题目选项，本表可协助评估您对私募基金及投资目标相关风险的态度，确定您对投资风险的适应力，进而为您推荐更适合投资的产品。衷心感谢您对我们的支持与信任。</p>
    <p>重要提示：</p>
    <p>1、请投资者认真阅读问卷内容，了解评分规则，并确认所填写内容表达真实。</p>
    <p>2、本网站根据投资者的风险承受能力等级，对投资者的投资行为作出是否匹配的检查和提示。本次调查结果不构成对投资者的投资建议，或对投资者的投资决策形成实质影响</p>
    <p>3、投资有风险，可能导致投资者产生亏损，请投资者在购买过程中注意根据调查结果核对自己的风险承受能力和基金产品风险匹配情况。无论投资者是否根据调查结果进行投资，均属投资者的独立行为，相应的风险亦由投资者独立承担。</p>
    <p>调查题目（所有题目均为单选题）</p>
    <div v-for="(item,index) in personalPager.questionType" :key="index">
      <p>{{item.typeName}}</p>
      <div v-for="(question,inde) in item.question" v-if="question.isMultiple==0" :key="question.questionId">
        <p>{{inde+1}}.{{question.questionBody}}</p>
        <div v-for="(questionoption,ind) in question.optionBodys" :key="questionoption.id">
          <p><span><input :name="question.questionId" @click="submitOption(question.questionId,questionoption.id)"
                          type="radio" :value="questionoption.id" :checked="questionoption.defaultAnswers"/>{{String.fromCharCode(ind+65)}}.{{questionoption.body}}</span>
          </p>
        </div>
      </div>
      <div v-for="(question,inde) in item.question" v-if="question.isMultiple==1" :key="question.questionId">
        <p>{{inde+1}}.{{question.questionBody}}</p>
        <div v-for="(questionoption,ind) in question.optionBodys" :key="questionoption.id">
          <p><span><input :name="question.questionId" @click="submitOption(question.questionId,questionoption.id)"
                          type="checkbox" :value="questionoption.id" :checked="questionoption.defaultAnswers"/>{{String.fromCharCode(ind+65)}}.{{questionoption.body}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="finish" @click="submitquestions">完成</div>
</div>
  </div>
</template>
<script>

  import {http} from '../fetch/api'

  export default {
    data() {
      return {
        activeTab: 'survey',
        mobile: '',
        verifyCode: '',
        password: '',
        institutionPaper: {},
        personalPager: {}
      }
    },
    props: [
      "showsurvey"
    ],
    mounted() {
      this.getsurvey()
    },
    methods: {
      async submitOption(questionId, optionId) {
        var data = await http.saveAnswer(questionId, optionId)
        if (data.code == '0') {

        }
      },
      async getsurvey() {
        var data2 = await http.surveyPager("2")
        if (data2.code == '0') {
          this.institutionPaper = data2.data?data2.data:{}
          this.activeTab = 'survey'
        }
        var data1 = await http.surveyPager("1")
        if (data1.code == '0') {
          this.personalPager = data1.data?data1.data:{}
        }
      },
      async register() {
        var data = await http.register(this.mobile, this.verifyCode, this.password)
        if (data.code == '0') {
          // format.message("注册成功")
          this.$store.state.noticeMessage="注册成功"
        }
      },
      async getvercode() {
        if (!this.mobile) {
          // format.message("请输入手机号", "error")
          this.$store.state.noticeMessage="请输入手机号"
          return
        }
        var type = '1'
        var data = await http.verifyCode(this.mobile, type)
        if (data.code == '0') {
          // format.message("验证码已发送")
          this.$store.state.noticeMessage="验证码已发送"
        }
      },
      async submitquestions() {
        if (this.activeTab == 'persurvey') {
          var data = await http.surveySubmit("1")
          if (data.code == '0') {
            this.$emit("closesurvey")
          }
        }
        if (this.activeTab == 'survey') {
          var data = await http.surveySubmit("2")
          if (data.code == '0') {
            this.$emit("closesurvey")
          }
        }
      },
      handleClose() {
        this.$emit("closesurvey")
      },
      notClose(event) {
        event.stopPropagation()
      }
    }
  }
</script>
<style scoped>
  .logincon {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  .info-con {

    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  .eligible {
    background-image: url("../assets/hgtzzrd.png");
    width: 840px;
    height: 550px;
  }

  .text {
    font-size: 16px;
    margin: 30px 70px;
    text-align: left;
  }

  .text p {
    text-indent: 32px;
    line-height: 28px;
    letter-spacing: 1px;
  }

  .buttons div {
    display: inline-block;
    width: 240px;
    margin: 0 25px;
    color: #fff;
    border-radius: 6px;
    height: 50px;
    line-height: 50px;
  }

  .gray {
    background: #b5b5b5;
  }

  .light {
    background: #00bcbc;
  }

  .login {
    background-image: url("../assets/login.png");
    width: 840px;
    height: 550px;
  }

  .two-title {

  }

  .survey-title {
    display: inline-block;
    text-align: center;
    height: 68px;
    line-height: 68px;
    color: #6e7c8b;
    font-size: 30px;
    padding: 0 20px;
    font-family: MicrosoftYaHei-Bold;
  }
.active {
  color: #fff;
  text-shadow: 2px 2px 20px #0ff;
}
  .gologin {
    margin: 80px auto 0 auto;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    text-align: right;
    width: 400px;
    color: #fff;
  }

  .gologin span {
    cursor: pointer;
    color: #0ff;
  }

  .reg-info {
    width: 400px;
    margin: 0 auto;
  }

  .reg-info > div {
    position: relative;
  }

  .reg-info input {
    margin: 10px 0;
    background: #1f4661;
    width: 400px;
    height: 50px;
    border-radius: 6px;
    border: solid 1px #0ff;
    padding-left: 30px;
    box-sizing: border-box;
    outline: none;
    color: #fff;
  }

  .reg-info img {
    position: absolute;
    left: 10px;
    vertical-align: middle;
    top: 25px;
    width: 15px;
  }

  .vercode {
    text-align: center;
    display: inline-block;
    width: 100px;
    border-left: solid 1px #0ff;
    position: absolute;
    right: 0;
    height: 40px;
    line-height: 40px;
    color: #0ff;
    margin-top: 15px;
  }

  .button {
    width: 400px;
    height: 50px;
    background-color: #00ffff;
    border-radius: 6px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 8px;
    color: #06172f;
    margin-top: 20px;
    cursor: pointer;
  }

  .forgetpwd {
    text-align: right;
    color: #0ff;
    cursor: pointer;
  }

  .survey {
    background-image: url("../assets/jgtzzwj.png");
    width: 1020px;
    height: 735px;
  }

  .persurvey {
    background-image: url("../assets/grtzzwj.png");
    width: 1020px;
    height: 735px;
  }

  .survey p, .persurvey p {
    text-align: left;
  }

  .scroll-con {
    height: 500px;
    overflow: scroll;
  }

  /*滚动条整体样式*/
  .scroll-con::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .scroll-con::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #a4f1fc;
  }

  /*滚动条轨道*/
  .scroll-con::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: none;
  }

  .finish {
    width: 240px;
    background: #00bcbc;
    margin: 0 auto;
    color: #fff;
    height: 50px;
    line-height: 50px;
    border-radius: 6px;
  }

  .closebutton {
    position: absolute;
    color: #fff;
    right: 20px;
    top: -25px;
  }

  p .onlyline {
    display: block;
  }

  input[type="checkbox"] {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/survey.vue